import React, { useEffect, useState } from 'react';
import codes from '../../../utils/constants/codes';
import refreshPage from './refreshPage.module.scss';
import CheckedIcon from '../../icons/checkedIcon';
import { Button } from 'arag-ui-lib';
import warning from '../../../assets/images/warning.png';
import { store } from '../../../store/store';
import PhoneNoFillIcon from '../../icons/phoneNoFillIcon';
import EmailIcon from '../../icons/emailIcon';
import CopyPasteIcon from '../../icons/copyPasteIcon';
import { useTranslation } from 'react-i18next';
import aragLogo from '../../../assets/images/araglogo3@2x.png';

function RefreshPage() {
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        setTimeout(() => setCopied(false), 3000);
    }, [copied]);

    const copy = item => {
        const el = document.createElement('input');
        el.value = item;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        setCopied(true);
    };
    const currentCountryCode = store
        .getState()
        .applicationSettings.apiApplicationSettings?.currentCountryCode.toUpperCase();
    const { t } = useTranslation();
    return (
        <div
            className={`${refreshPage['content']}`}
            style={{
                backgroundImage: `url(${warning})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
            }}
        >
            <div className={`${refreshPage['logoText']}`}>
                <img
                    className={`${refreshPage['logo']}`}
                    src={aragLogo}
                    alt="ARAG Logo"
                />
                <div className={refreshPage['text']}>
                    <p>{codes.blankPage}</p>
                </div>
                <div className={refreshPage['secondary-text']}>
                    <p>{codes.refreshPage}</p>
                </div>
                <Button
                    variant="primary"
                    label={t('returnToHomePage')}
                    onClick={() => window.location.replace('/claims/list')}
                />
                <div className={refreshPage['secondary-text']}>
                    <p className={refreshPage['par']}>
                        {codes.continueContactUs}
                    </p>
                </div>
                <div className={'row'}>
                    <div className={`${refreshPage['email']} col-sm-1 `}>
                        <PhoneNoFillIcon className={refreshPage['mainIcon']} />
                    </div>
                    <div className={`${refreshPage['phone']} col-sm-10`}>
                        <p className={refreshPage['emailText']}>
                            {' '}
                            {codes[`emailContactNumber${currentCountryCode}`] ||
                                'Unknown'}
                        </p>
                    </div>
                </div>
                <div className={'row'}>
                    <div className={`${refreshPage['email']} col-sm-1 `}>
                        <EmailIcon className={refreshPage['mainIcon']} />
                    </div>
                    <div className={`${refreshPage['link']} col-sm-10`}>
                        <div className={refreshPage['tooltip']}>
                            <button
                                onClick={() =>
                                    copy(
                                        codes[
                                            `emailContactEmail${currentCountryCode}`
                                        ] || 'Unknown',
                                    )
                                }
                                className={refreshPage['btn']}
                                id={'refresh-button'}
                            >
                                <span
                                    className={refreshPage['tooltipText']}
                                    id={'tooltipText'}
                                >
                                    {codes.copyToClipboard}
                                </span>
                                {codes[
                                    `emailContactEmail${currentCountryCode}`
                                ] || 'Unknown'}
                                {!copied ? (
                                    <CopyPasteIcon
                                        className={refreshPage['icon']}
                                        id={'copyPaste'}
                                    />
                                ) : (
                                    <CheckedIcon
                                        className={refreshPage['icon']}
                                        id={'checked'}
                                    />
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RefreshPage;
